import React from 'react';

const UserProfile = () => {
    return (
        <svg viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 14.31C0 9.35442 0 6.87664 0.949098 4.97719C1.82024 3.23377 3.23377 1.82024 4.97719 0.949098C6.87664 0 9.35442 0 14.31 0H20.69C25.6456 0 28.1234 0 30.0228 0.949098C31.7662 1.82024 33.1798 3.23377 34.0509 4.97719C35 6.87664 35 9.35442 35 14.31V20.69C35 25.6456 35 28.1234 34.0509 30.0228C33.1798 31.7662 31.7662 33.1798 30.0228 34.0509C28.1234 35 25.6456 35 20.69 35H14.31C9.35442 35 6.87664 35 4.97719 34.0509C3.23377 33.1798 1.82024 31.7662 0.949098 30.0228C0 28.1234 0 25.6456 0 20.69V14.31Z"
                fill="#F3F4F9"
            />
            <ellipse
                cx="17.5045"
                cy="12.7222"
                rx="4.73102"
                ry="4.72216"
                stroke="#8D98B7"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10 23.012C9.99874 22.68 10.0731 22.3521 10.2175 22.0531C10.6707 21.1485 11.9486 20.669 13.009 20.4519C13.7738 20.289 14.5491 20.1802 15.3292 20.1262C16.7735 19.9996 18.2262 19.9996 19.6705 20.1262C20.4506 20.1808 21.2258 20.2896 21.9907 20.4519C23.0511 20.669 24.329 21.1032 24.7822 22.0531C25.0726 22.6627 25.0726 23.3704 24.7822 23.9799C24.329 24.9298 23.0511 25.364 21.9907 25.5721C21.2268 25.7417 20.4512 25.8536 19.6705 25.9068C18.495 26.0063 17.3139 26.0244 16.1358 25.9611C15.8639 25.9611 15.6011 25.9611 15.3292 25.9068C14.5514 25.8543 13.7788 25.7424 13.0181 25.5721C11.9486 25.364 10.6798 24.9298 10.2175 23.9799C10.0739 23.6774 9.99956 23.3468 10 23.012Z"
                stroke="#8D98B7"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default UserProfile;
